import React from "react";

/**
 * Designed for Real Needs — phone mockup + copy (Stitch our-app.html §2)
 */
const Mobilesection = () => {
  return (
    <div className="w-full">
      {/* Wave into soft surface */}
      <div
        className="w-full overflow-hidden leading-none -mt-1 text-surface-light rotate-180"
        aria-hidden="true"
      >
        <svg
          className="relative block w-full h-10 sm:h-12"
          preserveAspectRatio="none"
          viewBox="0 0 1200 120"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            fill="currentColor"
          />
        </svg>
      </div>

      <section className="py-16 sm:py-20 md:py-28 bg-surface-light relative text-left">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
            <div className="lg:col-span-6 flex justify-center relative order-2 lg:order-1">
              <div
                className="absolute -top-10 -left-6 w-56 sm:w-72 h-56 sm:h-72 rounded-full blur-3xl opacity-60 pointer-events-none"
                style={{ backgroundColor: "var(--color-cloud-mist)" }}
                aria-hidden="true"
              />

              {/* Phone frame */}
              <div className="relative w-[280px] sm:w-[310px] md:w-[340px] bg-ink rounded-[24px] p-2.5 sm:p-3 shadow-brand-lg border-4 border-ink z-10">
                <div className="bg-surface-white rounded-[16px] overflow-hidden flex flex-col h-[560px] sm:h-[640px] select-none text-left">
                  <div className="h-6 bg-surface-white flex justify-center items-center pt-1">
                    <div className="w-20 h-4 bg-ink rounded-full" />
                  </div>

                  <div className="px-4 sm:px-5 pt-3 pb-4 bg-surface-white border-b border-cloud-mist flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-brand bg-cloud-mist flex items-center justify-center text-spectrum-blue font-headline font-bold text-xs">
                        SS
                      </div>
                      <div>
                        <h3 className="font-headline text-xs font-bold text-ink">
                          Community Feed
                        </h3>
                        <p className="text-[10px] text-muted-soft">
                          Sydney North Circle
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="p-3 sm:p-4 space-y-3 sm:space-y-4 overflow-y-auto flex-1"
                    style={{
                      backgroundColor:
                        "color-mix(in srgb, var(--color-cloud-mist) 25%, var(--color-white))",
                    }}
                  >
                    <div className="bg-surface-white p-3.5 rounded-brand border border-hairline shadow-sm space-y-2.5">
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2 min-w-0">
                          <div className="w-8 h-8 rounded-full bg-cloud-mist flex items-center justify-center text-spectrum-blue font-bold text-xs shrink-0">
                            EM
                          </div>
                          <div className="min-w-0">
                            <p className="font-headline text-xs font-bold text-ink truncate">
                              Elena Mitchell
                            </p>
                            <p className="text-[10px] text-muted-soft">
                              Parent of 6yo • 15m ago
                            </p>
                          </div>
                        </div>
                        <span className="shrink-0 text-[10px] font-semibold bg-cloud-mist text-spectrum-blue px-2 py-0.5 rounded-full">
                          Sensory Tips
                        </span>
                      </div>
                      <p className="text-xs text-muted leading-relaxed">
                        &ldquo;Found an incredible sensory-friendly music morning
                        at Centennial Park this Saturday. Who else wants to meet
                        up?&rdquo;
                      </p>
                      <div className="flex items-center gap-4 text-[11px] text-muted-soft pt-1 border-t border-cloud-mist">
                        <span className="text-heart-teal font-semibold">
                          ♥ 18
                        </span>
                        <span>9 replies</span>
                      </div>
                    </div>

                    <div
                      className="p-3.5 rounded-brand border border-sky-soft shadow-sm space-y-2"
                      style={{
                        backgroundColor:
                          "color-mix(in srgb, var(--color-cloud-mist) 50%, var(--color-white))",
                      }}
                    >
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2 min-w-0">
                          <div className="w-7 h-7 rounded-brand bg-spectrum-blue text-surface-white flex items-center justify-center text-[10px] font-bold shrink-0">
                            SJ
                          </div>
                          <div className="min-w-0">
                            <p className="font-headline text-xs font-bold text-spectrum-blue truncate">
                              Dr. Sarah Jenkins
                            </p>
                            <p className="text-[10px] text-muted-soft truncate">
                              Occupational Therapist • Verified
                            </p>
                          </div>
                        </div>
                        <span className="shrink-0 px-2 py-0.5 bg-sunshine text-ink font-bold text-[9px] rounded-full">
                          Available
                        </span>
                      </div>
                      <p className="text-xs text-muted">
                        Specialized in emotional co-regulation and gentle sensory
                        integration.
                      </p>
                    </div>

                    <div className="bg-surface-white p-3.5 rounded-brand border border-hairline shadow-sm flex items-center gap-3">
                      <div className="w-10 h-10 rounded-brand bg-sunshine-soft flex flex-col items-center justify-center text-spectrum-blue font-bold shrink-0">
                        <span className="text-[9px] leading-tight">OCT</span>
                        <span className="text-xs leading-tight">24</span>
                      </div>
                      <div className="min-w-0">
                        <p className="font-headline text-xs font-bold text-ink truncate">
                          Calm Coding Workshop
                        </p>
                        <p className="text-[10px] text-muted-soft truncate">
                          Small groups (Max 6) • Sydney CBD
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="px-4 py-2.5 bg-surface-white border-t border-cloud-mist flex justify-around items-center text-spectrum-blue text-xs font-semibold">
                    <span>Home</span>
                    <span className="text-muted-soft">Search</span>
                    <span className="text-muted-soft">Events</span>
                    <span className="text-muted-soft">Profile</span>
                  </div>
                </div>
              </div>

              <div className="hidden sm:flex flex-col gap-3 absolute -right-2 md:-right-6 top-1/4 z-20 max-w-[200px]">
                <div className="bg-surface-white p-3 rounded-brand border border-cloud-mist shadow-brand-sm flex items-center gap-2">
                  <span className="text-heart-teal text-sm font-bold" aria-hidden="true">
                    ✓
                  </span>
                  <span className="font-headline text-xs font-bold text-spectrum-blue">
                    Safe & Moderated Village
                  </span>
                </div>
                <div className="bg-surface-white p-3 rounded-brand border border-cloud-mist shadow-brand-sm flex items-center gap-2">
                  <span className="text-sunshine text-sm font-bold" aria-hidden="true">
                    ✶
                  </span>
                  <span className="font-headline text-xs font-bold text-ink">
                    Filters by Age & Needs
                  </span>
                </div>
              </div>
            </div>

            <div className="lg:col-span-6 flex flex-col items-start order-1 lg:order-2">
              <div className="inline-block px-3 py-1 rounded-full bg-cloud-mist text-spectrum-blue text-xs font-headline font-bold tracking-wide uppercase mb-4">
                Community-First Architecture
              </div>
              <h2 className="font-headline text-2xl sm:text-3xl lg:text-4xl text-ink mb-5 sm:mb-6 tracking-tight">
                <span className="font-light block text-muted">Designed for</span>
                <span className="font-extrabold block text-spectrum-blue">
                  Real Needs
                </span>
              </h2>
              <p className="font-body text-[15px] sm:text-base md:text-lg text-muted leading-relaxed mb-7 sm:mb-8 max-w-[560px]">
                Social Spectrum combines{" "}
                <strong className="text-ink font-semibold">parent support</strong>
                ,{" "}
                <strong className="text-ink font-semibold">
                  professional resources
                </strong>
                , and{" "}
                <strong className="text-ink font-semibold">
                  local connections
                </strong>{" "}
                in one intuitive platform. We&apos;re making it easier for
                families navigating neurodivergence to find their community and
                access neurodiversity family support.
              </p>

              <div className="space-y-4 w-full max-w-lg">
                <div className="flex items-start gap-4 p-4 rounded-brand bg-surface-white border border-cloud-mist">
                  <div className="w-10 h-10 rounded-brand bg-cloud-mist flex items-center justify-center text-spectrum-blue shrink-0">
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      stroke="currentColor"
                      strokeWidth="1.75"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-headline text-sm font-bold text-ink mb-1">
                      Peer-to-Peer Empathy
                    </h3>
                    <p className="font-body text-sm text-muted">
                      Real conversations free from judgment, led by parents living
                      similar journeys.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 rounded-brand bg-surface-white border border-cloud-mist">
                  <div className="w-10 h-10 rounded-brand bg-cloud-mist flex items-center justify-center text-spectrum-blue shrink-0">
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      stroke="currentColor"
                      strokeWidth="1.75"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-headline text-sm font-bold text-ink mb-1">
                      Curated & Verified Providers
                    </h3>
                    <p className="font-body text-sm text-muted">
                      Every professional on the platform is vetted for genuine
                      neurodiversity-affirming care.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Mobilesection;
